import {Base} from "@/api/Base"

export class LeaveTypeDelete extends Base {
    path = "leaveType/delete"
}